<template>
  <b-overlay
    :show="__isOnLoad"
    variant="white"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    style="float: left; width: 100%"
  >
    <div class="inFacture" v-if="__inFacture && item">
      <h1>{{ item.name }}</h1>
      <h3>{{ item.ville }}, {{ item.adress }}</h3>
      <br />
      <em
        >Tél : <b>{{ item.tel }}</b> <br />
        Email : <b>{{ item.email }}</b> <br />
        Fax :
        <b>{{ item.fax }}</b>
        <br />
        MF : {{ item.mf }} <br />
        NRC : {{ item.nrc }} </em
      >
      <br />
    </div>
    <div class="recap" v-if="!__inFacture">
      <div class="history">
        Factures :
        <b-icon
          icon="exclamation-circle-fill"
          style="color: green"
          font-scale="1"
          @click="showHist = !showHist"
        ></b-icon>
        {{ factVente }}<br />

        <b>CA : {{ formatMoney(totalVente) }} HT</b><br />
      </div>

      <div class="info" v-if="item">
        <div class="pic">
          <img :src="getTof(item.logo || null)" style="width: 80px" />
        </div>
        <h1>{{ item.name }}</h1>
        <h3>{{ item.ville }}, {{ item.adress }}</h3>
        <em
          >Tél : <b>{{ item.tel }}</b> - Email : <b>{{ item.email }}</b> - Fax :
          <b>{{ item.fax }}</b></em
        >
        <br />
        Banque : {{ item.banque }} - MF : {{ item.mf }} - NRC : {{ item.nrc }} -
        CD : {{ item.cd }}
      </div>

      <br />
      <div
        class="row item"
        v-for="(_item, idx) in history"
        :key="idx"
        v-if="showHist"
      >
      <div class="col-md-1">
          <b-icon
            icon="card-heading"
            style="color: blue"
            font-scale="1.5"
            @click="fnshowFact(_item)"
          ></b-icon>
        
        </div>
        <div class="col-md-7">
          
          <b>N° {{ _item.num }} / {{ _item.exercice }}</b> <br />
          <em style="font-size: 10px">{{
            __._getDate(_item.createdAt)
          }}</em>
        </div>
        <div class="col-md-4" style="text-align: right">
          {{ formatMoney(_item.totalHT) }} HT
        </div>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import Vue from "vue";
export default {
  props: {
    __ID: {
      type: String,
      default: () => {
        return "";
      },
    },
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },

    __inFacture: {
      type: Boolean,
      default: () => {
        return true;
      },
    },

    __showHist: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },

  data() {
    return {
      item: null,
      onGoingReq: [],
      factVente: 0,
      totalVente: 0,
      history: [],
      showHist: false,
      showFact: null,
    };
  },
  methods: {
    formatMoney(value) {
      return Number(value || 0).toFixed(3);
    },

    loadData() {
      let $onNext = (response) => {
        this.item = response.data[0];
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      this.onGoingReq.push({});
      this.__.httpAction({
        methode: "GET",
        route: "/societes/" + this.$props.__ID,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    fnshowFact(fact) {
      this.showFact = fact;
      this.showPopup = true;
    },

    loadFact() {
      let $onNext = (response) => {
        this.totalVente = 0;
        this.history = response.data;
        this.factVente = this.history.length;
        this.history = this.history
          .map((fact) => {
            this.totalVente += Number(fact.totalHT);
            return { ...fact };
          })
          .sort((a, b) => Number(b.num || 0) - Number(a.num || 0));
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      this.onGoingReq.push({});
      const exercice = Vue.$cookies.get("exercice");

      this.__.httpAction({
        methode: "GET",
        route:
          "/factures/FACTURE/" + exercice + "/byclient/" + this.$props.__ID,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    getTof(c) {
      return this.__.resolveMediaPath(c, "uploads/societes/No-Image.jpg");
    },
  },
  watch: {
    __isOnLoad: function () {},
  },
  computed: {},
  mounted() {
    this.showHist = this.$props.__showHist;
    setTimeout(() => {
      this.loadData();
      this.loadFact();
    }, 400);
  },
};
</script>
<style scoped>
.item {
  margin-left: 0px !important;
  margin-right: 0px !important;
  background-color: #fff;
  margin-top: 2px;
  border-radius: 10px;
  color: black;
  font-size: 12px;
  padding: 5px;
}
.recap {
  padding: 10px;
  border-radius: 10px;
  background-color: #f2f2f2;
  color: #999;
  font-size: 10px;
  margin-bottom: 10px;
}
.pic {
  width: 80px;
  float: left;
  margin-right: 10px;
}
h1 {
  font-size: 20px;
  color: #000;
}
h3 {
  font-size: 10px;
  color: #000;
}

.info {
}
.history {
  float: right;
  color: #000;
  font-size: 12px;
}

.inFacture {
  color: #000;
  font-size: 12px;
  text-align: right;
  background: #F2F2F2;
    padding: 10px;
    border: solid 1px;
    margin-bottom: 15px;
}
</style>
